import NotificationSound from "../assets/sounds/notification.mp3";
import SosSound from "../assets/sounds/sos.mp3";

const notification = new Audio(NotificationSound);
const sos = new Audio(SosSound);

export const playNotificationSoundEffect = () => {
  notification.play();
};

export const playSosSoundEffect = () => {
  sos.play();
};